<div class="w-full bg-white border-box radius-10" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="sirets-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="">
          <div>
            <p class="no-margin light-blue bold">Listes des SIRET des autres établissements concernés</p>
            <p class="no-margin dark-gray text-sm">
              Bloc optionnel - Ajoutez les SIRET des autres établissements concernés par cette élection
            </p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>

    <div>
      <button (click)="toggleExpand()" class="pointer"
        style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
        <span [style.transform]="isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'"
          style="display: inline-block; transition: transform 0.3s;">›</span>
      </button>
    </div>
  </div>


  <div *ngIf="isExpanded" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="information-grid"
    class="p-20">


    <p *ngIf="sirets.sirets.length == 0" class="dark-gray no-margin bold">Aucun SIRET ajouté</p>
    <div *ngFor="let siret of sirets.sirets; let i = index; trackBy: trackByIndex" style=" grid-column: 1 / -1">
      <p class="dark-gray no-margin bold">SIRET {{i + 1}}</p>
      <div class="flex content-between gap-10 align-items-center">
        <p class="dark-blue bold">{{siret}}</p>
      </div>
    </div>

  </div>
  <div class="flex content-between p-20">
    <button class="edit-button" (click)="onEdit()">
      <img src="assets/pen-icon.svg" alt="">
      Modifier
    </button>
    <button *ngIf="!isValidated" class="validate-button" (click)="onValidate()">
      <img src="assets/valid-white-icon.svg" alt=""> Valider
    </button>
    <button *ngIf="isValidated" class="validated-button">
      <img src="assets/valid-green-icon.svg" alt="">
    </button>
  </div>
</div>